import { withStyles, LinearProgress } from "@material-ui/core";

export const CompleteLinearProgress = withStyles(theme => ({
    colorPrimary: {
        backgroundColor: theme.palette.success.light,
    },
    barColorPrimary: {
        backgroundColor: theme.palette.success.main,
    },
}))(LinearProgress);